import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

import { orderStatus } from '../utils/index';

@Injectable()
export class ScheduleQueryService {

    orderStatus = orderStatus;

    public GET_SCHEDULE_REQUEST_BY_REPORTID: any;
    public CREATE_SCHEDULE_REQUEST: any;
    private UPDATE_SCHEDULE_REQUEST: any;
    public GET_ALL_ROLES: any;

    constructor(public apollo: Apollo) {

        this.GET_ALL_ROLES = gql`
                query GetClientRoles($roleDiv:Boolean!){
                        allRoles(condition:{roleDiv:$roleDiv}){
                            nodes{
                                roleName
                                roleId
                                roleDiv
                        }
                    }
                }
        `;
        this.GET_SCHEDULE_REQUEST_BY_REPORTID =
            gql`                                
            query GetReturnSelectedId($insReportId:String!) {
                allScheduleRequests(condition:{scheduleRequestId:$insReportId}) {
                        nodes {
                            statusId
                            buyerProperty
                            orderId
                            acceptedBy
                            scheduleRequestDate
                            contactName
                            contactEmail
                            contactPhone
                            additionalShare
                            clientinitial                        
                            userRole
                            agentName
                            agentEmail
                            isOccupied
                            workContactName
                            workContactEmail
                            workContactPhone
                            wcRole
                            buyerAgentName
                            sellerAgentName
                            closingDate
                            workBeginDate
                            closingName
                            closingPhone
                            responsibleRole
                            isPrior
                            isPaymentClosed
                            additionalWork
                            signDate
                            progressContact
                            paymentContact
                            scheduleInfo
                            paymentEmail
                            paymentPhone
                        }
                    }
            }

        `;

        // Mutaion - CREATE_SCHEDULE_REQUEST  detail
        this.CREATE_SCHEDULE_REQUEST = gql` 
            mutation CREATE_SCHEDULE_REQUEST($input: CreateScheduleRequestInput!) {
                createScheduleRequest(input: $input) {
                    scheduleRequest{                    
                        scheduleRequestId         
                    }
            }
         }
         `;

        this.UPDATE_SCHEDULE_REQUEST = gql`
            mutation updateRequest($input:UpdateScheduleRequestByScheduleRequestIdInput!){
                updateScheduleRequestByScheduleRequestId(input:$input){
                    scheduleRequest{
                        scheduleRequestId   
                    }
                    
                }
             }
         `;

    }

    // Check this report already saved or not 
    isReportAccept(): any {
        return this.apollo
            .watchQuery({
                query: this.GET_SCHEDULE_REQUEST_BY_REPORTID
                ,
                variables:
                {
                    'insReportId': window.localStorage.getItem('reportId').trim(),
                },
                fetchPolicy: 'network-only'
            });
    }

    // Insert schdule request  details
    insertSchduleRequest(orderId, dates, buyerProperty, formvalues, share, initial): any {
        return this.apollo.mutate({
            mutation: this.CREATE_SCHEDULE_REQUEST,
            variables: {
                'input': {
                    'scheduleRequest': {
                        'createdAt': new Date(),
                        'scheduleRequestId': window.localStorage.getItem('reportId').trim(),
                        'orderId': orderId,
                        'scheduleRequestDate': dates.deadLineDate,
                        'buyerProperty': buyerProperty,
                        'statusId': this.orderStatus[3].id,
                        'contactName': formvalues.firstFormGroup.name,
                        'contactEmail': formvalues.firstFormGroup.email,
                        'contactPhone': formvalues.firstFormGroup.phone,
                        'clientinitial': initial,
                        'statusChangeAt': new Date(),
                        'userRole': formvalues.firstFormGroup.role,
                        'agentName': formvalues.firstFormGroup.agentName,
                        'agentEmail': formvalues.firstFormGroup.agentEmail,
                        'workContactName': formvalues.firstFormGroup.contactName,
                        'workContactEmail': formvalues.firstFormGroup.contactEmail,
                        'workContactPhone': formvalues.firstFormGroup.contactPhone,
                        'wcRole': formvalues.firstFormGroup.workResponsibleRole,
                        'buyerAgentName': formvalues.firstFormGroup.buyerAgentName,
                        'sellerAgentName': formvalues.firstFormGroup.sellerAgentName,
                        'closingDate': dates.closingDate,
                        'workBeginDate': dates.beginWorkDate,
                        'closingName': formvalues.secondFormGroup.closingAttroneyName,
                        'closingPhone': formvalues.secondFormGroup.closingAttroneyPhone,
                        'responsibleRole': formvalues.firstFormGroup.finResponsiblePayment,
                        'isPrior': formvalues.secondFormGroup.prior,
                        'isPaymentClosed': formvalues.firstFormGroup.transClose,
                        'isOccupied': formvalues.firstFormGroup.occupied,
                        'signDate': formvalues.firstFormGroup.finalSubmitDate,
                        'additionalShare': formvalues.firstFormGroup.share,
                        'additionalWork': formvalues.firstFormGroup.additionalWork,
                        'progressContact': formvalues.firstFormGroup.whoWorkContact,
                        'paymentContact': formvalues.firstFormGroup.whoPaymentContact,
                        'scheduleInfo': formvalues.firstFormGroup.scheduleInfo,
                        'paymentEmail': formvalues.firstFormGroup.whoPaymentEmail,
                        'paymentPhone': formvalues.firstFormGroup.whoPaymentPhone,
                        "acceptStatus": "work_requested"
                    }
                },

            }
        });
    }
    // Insert schdule request  details
    updateSchduleRequest(dates, formvalues, share, initial, buyerProperty): any {
        return this.apollo.mutate({
            mutation: this.UPDATE_SCHEDULE_REQUEST,
            variables: {
                'input': {
                    "scheduleRequestId": window.localStorage.getItem('reportId').trim(),
                    'scheduleRequestPatch': {
                        'scheduleRequestDate': dates.deadLineDate,
                        'contactName': formvalues.firstFormGroup.name,
                        'contactEmail': formvalues.firstFormGroup.email,
                        'contactPhone': formvalues.firstFormGroup.phone,
                        'clientinitial': initial,
                        'statusChangeAt': new Date(),
                        'buyerProperty': buyerProperty,
                        'statusId': this.orderStatus[3].id,
                        'userRole': formvalues.firstFormGroup.role,
                        'agentName': formvalues.firstFormGroup.agentName,
                        'agentEmail': formvalues.firstFormGroup.agentEmail,
                        'workContactName': formvalues.firstFormGroup.contactName,
                        'workContactEmail': formvalues.firstFormGroup.contactEmail,
                        'workContactPhone': formvalues.firstFormGroup.contactPhone,
                        'wcRole': formvalues.firstFormGroup.workResponsibleRole,
                        'buyerAgentName': formvalues.firstFormGroup.buyerAgentName,
                        'sellerAgentName': formvalues.firstFormGroup.sellerAgentName,
                        'closingDate': dates.closingDate,
                        'workBeginDate': dates.beginWorkDate,
                        'closingName': formvalues.secondFormGroup.closingAttroneyName,
                        'closingPhone': formvalues.secondFormGroup.closingAttroneyPhone,
                        'responsibleRole': formvalues.firstFormGroup.finResponsiblePayment,
                        'isPrior': formvalues.secondFormGroup.prior,
                        'isPaymentClosed': formvalues.firstFormGroup.transClose,
                        'isOccupied': formvalues.firstFormGroup.occupied,
                        'signDate': formvalues.firstFormGroup.finalSubmitDate,
                        'additionalShare': formvalues.firstFormGroup.share,
                        'additionalWork': formvalues.firstFormGroup.additionalWork,
                        'progressContact': formvalues.firstFormGroup.whoWorkContact,
                        'paymentContact': formvalues.firstFormGroup.whoPaymentContact,
                        'scheduleInfo': formvalues.secondFormGroup.scheduleInfo,
                        'paymentEmail': formvalues.firstFormGroup.whoPaymentEmail,
                        'paymentPhone': formvalues.firstFormGroup.whoPaymentPhone,
                        "acceptStatus": "work_requested"
                    }
                },

            }
        });
    }

    // Get Respective Customer roles Get
    getAllRoles(): any {
        return this.apollo
            .watchQuery({
                query: this.GET_ALL_ROLES,
                variables: {
                    'roleDiv': false,
                },
                fetchPolicy: 'network-only',
            });
    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/main/content/gql-query-mutation/schedule-request.service.ts